export const materials = [
    {
        id: 1,
        name: "Բուսաբանություն՝ բ-րի անատոմիա և մորֆոլոգիա",
        info: "Դիտել",
        file: "../../files/biology/materials/1.pdf",
        menuItemId: 5
    },
    {
        id: 2,
        name: "Բուսաբ․ լաբորատոր պարապմունքներ",
        info: "Դիտել",
        file: "../../files/biology/materials/2.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Բջջաբանություն",
        info: "Դիտել",
        file: "../../files/biology/materials/3.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Հայաստանի կենսաբազմազանությունը ",
        info: "Դիտել",
        file: "../../files/biology/materials/4.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Հայաստանի ձկները",
        info: "Դիտել",
        file: "../../files/biology/materials/5.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Հայաստանի ձկները հիշատակարան",
        info: "Դիտել",
        file: "../../files/biology/materials/6.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Հայաստանի ձկների ուղեցույց որոշիչ",
        info: "Դիտել",
        file: "../../files/biology/materials/7.pdf",
        menuItemId: 5
    },
    {
        id: 1,
        name: "Ջրիմուռներ, սնկեր ուս․ձեռնարկ",
        info: "Դիտել",
        file: "../../files/biology/materials/8.pdf",
        menuItemId: 5
    },

];


